/*
 * @Author: weijinpeng
 * @LastEditors: weijinpeng
 * @Date: 2023-08-07 15:36:07
 * @LastEditTime: 2024-06-05 11:48:50
 * @Description: 
 */
import { defineStore } from 'pinia'
import pdf from '@/api/pdf'
import authority from '@/api/authority';
import { formatDate } from '@/utils/date'
import { message } from 'ant-design-vue';

export const usePdftStore = defineStore('pdf', {
    state: () => {
        return {
            fromData: {},
            queid: null,
            spinning: false
        }
    },
    getters: {},
    actions: {
        //获取pdf
        getReport(params, router, id) {
            pdf.getReport(res => {
                this.spinning = false
                if (res.code == 200) {
                    this.fromData = res.data
                }
            }, params)
        },
        //上传pdf
        postFile(params,router) {
            pdf.postFile(res => {
                if (res.code == 200) {
                    let params1 = {
                        queId: this.queid,
                        reportId: res.data.id,
                        stage: 10
                    }
                    this.postId(params1,router)
                }
            }, params)
        },
        postId(params,router) {
            pdf.postId(response => {
                if (response.code == 200) {
                    message.success('发送成功')
                    this.spinning = false
                    router.push('/scoring')
                }
            }, params)
        }
    },
})